import { initializeApp, getApps } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getStorage, connectStorageEmulator } from 'firebase/storage'

const firebaseConfig = {
  apiKey:            import.meta.env['VITE_FIREBASE_API_KEY'],
  authDomain:        import.meta.env['VITE_FIREBASE_AUTH_DOMAIN'],
  projectId:         import.meta.env['VITE_FIREBASE_PROJECT_ID'],
  storageBucket:     import.meta.env['VITE_FIREBASE_STORAGE_BUCKET'],
  messagingSenderId: import.meta.env['VITE_FIREBASE_MESSAGING_SENDER_ID'],
  appId:             import.meta.env['VITE_FIREBASE_APP_ID'],
}

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0]!
export const auth    = getAuth(app)
export const storage = getStorage(app)

// Connect to Auth emulator in local dev
const authEmulatorUrl = import.meta.env['VITE_AUTH_EMULATOR_URL'] as string | undefined
if (authEmulatorUrl) {
  connectAuthEmulator(auth, authEmulatorUrl, { disableWarnings: true })
}

// Connect to Storage emulator in local dev
const storageEmulatorHost = import.meta.env['VITE_STORAGE_EMULATOR_HOST'] as string | undefined
if (storageEmulatorHost) {
  const [host, portStr] = storageEmulatorHost.split(':')
  connectStorageEmulator(storage, host!, parseInt(portStr ?? '9481', 10))
}
